export enum DatapointAggregateFieldType {
    FIELD = 'FIELD', //when aggregate is done based on simple fields
    FORMULA = 'FORMULA'//when aggregate is done based on formula that includes multiple fields
}